import getDevice from './module/getDevice.js'
import functions from './functions.js' 
//import transitions from './module/transitions.js' // Activamos functions si usamos Barba.js
// import getBaseUrl from './module/getBaseUrl.js'
// const baseUrl = getBaseUrl()
// console.log('URL base detectada:', baseUrl)

const deviceData = getDevice()

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', getDevice)
window.addEventListener('orientationchange', getDevice)

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
  // Activamos si usamos Barba.js
  // transitions(deviceData)
})
